import React from "react";
import CsvDownloadButton from "../../common/components/CsvDownloadButton";
import { usePlayersContext } from "../../../state/players/context";

const CsvSampleFileButton = () => {
	const { state } = usePlayersContext();
	const csvHeaders = state.csvHeaders();

	return (
		<CsvDownloadButton csvContent={csvHeaders} filename="tennis_roster.csv" />
	);
};

export default CsvSampleFileButton;
